module.exports = __webpack_public_path__ + "img/marketing.b37989ed.svg";